import React from 'react';

import { Toolbar } from 'primereact/toolbar'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { Field } from 'react-form'

// wrappers for prime react form fields
import FieldInputText from '../common/FieldInputText'
import FieldCalendar from '../common/FieldCalendar'
import FieldDropdown from '../common/FieldDropdown'
import FieldFileUpload from '../common/FieldFileUpload'
import FieldInputTextarea from '../common/FieldInputTextarea';
import { EMPLOYEE_TYPE_UNDERTAKING, EMPLOYEE_TYPE_OTHER } from "../../js/const"

import '../../css/employee-details.css'

const EmployeeDetailsDialogFooter = ({ submitForm, isAdd, canSave, deleteEmployee, type, currentEmployee, isAnnualReturn, isAdmin }) => {
    return (
        <React.Fragment>
            {canSave === true && isAnnualReturn === false && <Toolbar>
                <div className="p-toolbar-group-left">
                    <Button label="Save" icon="pi pi-check" onClick={submitForm} />
                </div>
                {isAdmin && <div className="p-toolbar-group-right">
                    {isAdd === false && <Button icon="pi pi-times" className="p-button-danger" label="Delete" onClick={() => deleteEmployee(type, currentEmployee.EmployeeId)} />}
                    {/* {isAdd === false && isAnnualReturn === false && <ConfirmDialog buttonLabel="Delete" buttonIcon="pi pi-times" buttonIconPos="left" buttonClassName="p-button-danger" handleOnYesClick={() => deleteEmployee(type, currentEmployee.EmployeeId)}
            title={'Confirm employee deletion'} message={'Are you sure you wish to delete this employee?'}
          />} */}
                </div>}
            </Toolbar>}
        </React.Fragment>
    )
}

const EmployeeDetails = ({ submitForm, resetForm, canSave, closeEmployeeDetails, canSeePrivateData, statDecUpload, currentEmployee, employeeRestrictions, type, isDisplayingDialog, downloadStatDec, deleteEmployee, isAnnualReturn, isAdmin }) => {
    let validationRules = currentEmployee.ValidationRules ? currentEmployee.ValidationRules.$values : []
    let showAsTextOnly = canSave === false || isAnnualReturn
    let header = ""
    switch (type) {
        case EMPLOYEE_TYPE_UNDERTAKING:
            header = "People undertaking lobbyist activities"
            break
        case EMPLOYEE_TYPE_OTHER:
            header = "Other Employees"
            break
        default:
            header = ""
    }
    let isUndertakingLobbyistActivity = type === EMPLOYEE_TYPE_UNDERTAKING
    let isAdd = !currentEmployee.EmployeeId
    let dialogFooter = <EmployeeDetailsDialogFooter submitForm={submitForm} isAdd={isAdd} canSave={canSave} deleteEmployee={deleteEmployee} currentEmployee={currentEmployee} type={type} isAnnualReturn={isAnnualReturn} isAdmin={isAdmin} />
    return (
        <Dialog visible={isDisplayingDialog} header={header} modal={true} footer={dialogFooter} onHide={() => { closeEmployeeDetails(type, resetForm); }}>
            <div className="p-grid">
                <div className="p-col-12">
                    {(isAdd || isAdmin) && <FieldInputText field={"Name"} label={"Name"} validationRules={validationRules} showAsTextOnly={showAsTextOnly} />}
                    {(!isAdd && !isAdmin) && <FieldInputText field={"Name"} label={"Name"} validationRules={validationRules} showAsTextOnly={!isAdd} />}
                </div>
                <div className="p-col-12">
                    <FieldInputText field={"Position"} label={"Position"} validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
                </div>
                {isUndertakingLobbyistActivity && (isAdd || isAdmin) && <div className="p-col-12">
                    <FieldDropdown field={"RestrictionLookup"} label={"Restriction"} options={employeeRestrictions}
                        validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
                </div>}
                {isUndertakingLobbyistActivity && (!isAdd && !isAdmin) && <div className="p-col-12">
                    <FieldDropdown field={"RestrictionLookup"} label={"Restriction"} options={employeeRestrictions}
                        validationRules={validationRules} showAsTextOnly={!canSave} />
                </div>}
                {isUndertakingLobbyistActivity && <div className="p-col-12">
                    <Field field={"RestrictionLookup"}>
                        {fieldApi => {
                            const val = fieldApi && fieldApi.value ? fieldApi.value : currentEmployee.RestrictionLookup
                            let isOtherSelected = false
                            if (val) {
                                if (typeof val === 'object') {
                                    const sys = val.SystemCode || ''
                                    const desc = val.Description || ''
                                    isOtherSelected = (sys && sys.toString().toUpperCase().indexOf('OTHER') > -1) || (desc && desc.toString().toUpperCase() === 'OTHER')
                                }
                            }
                            return (
                                <FieldInputText field={"OtherRestrictionDetails"} label={"Other Restriction Details"} validationRules={validationRules} showAsTextOnly={showAsTextOnly} disabled={!isOtherSelected} />
                            )
                        }}
                    </Field>
                </div>}
                {isUndertakingLobbyistActivity && isAnnualReturn === false && <div className="p-col-6">
                    <FieldCalendar field={"RestrictionStartDate"} label={"Restriction Start Date"} validationRules={validationRules} showAsTextOnly={showAsTextOnly} viewDate={currentEmployee.RestrictionStartDate} />
                </div>}
                {isUndertakingLobbyistActivity && isAnnualReturn === false && <div className="p-col-6">
                    <FieldCalendar field={"RestrictionEndDate"} label={"Restriction End Date"} validationRules={validationRules} showAsTextOnly={showAsTextOnly} viewDate={currentEmployee.RestrictionEndDate} />
                </div>}

                {canSeePrivateData && isUndertakingLobbyistActivity && isAdd === false && currentEmployee.StatDecFilename && <div className="p-col-12 ui-md-12 ui-lg-12">
                    Uploaded Stat Dec
                </div>}
                {canSeePrivateData && isUndertakingLobbyistActivity && currentEmployee.StatDecFilename && <div className="p-col-12 ui-md-12 ui-lg-12">
                    <Button className={"download-stat-dec-button"} onClick={(e) => downloadStatDec(e, currentEmployee.EmployeeId)} label={"Download " + currentEmployee.StatDecFilename}> </Button>
                </div>}
                {isAnnualReturn === false && isUndertakingLobbyistActivity && canSave && <div className="p-col-12 ui-md-12 ui-lg-12">
                    <FieldFileUpload field={"StatDec"} name="StatDec" accept=".pdf" uploadRef={statDecUpload} label="Upload Stat Dec" hasSavedFile={currentEmployee.StatDecExists}
                        validationRules={validationRules} />
                </div>}
                {isAnnualReturn === false && <div className="p-col-6">
                    <FieldCalendar field={"StartDate"} label={"Start Date"} validationRules={validationRules} showAsTextOnly={showAsTextOnly} viewDate={currentEmployee.StartDate} />
                </div>}
                {isAnnualReturn === false && <div className="p-col-6">
                    <FieldCalendar field={"EndDate"} label={"End Date"} validationRules={validationRules} showAsTextOnly={showAsTextOnly} viewDate={currentEmployee.EndDate} />
                </div>}
                {isAnnualReturn === false && (
                <div className="p-col-12">
                    <FieldInputTextarea rows={3} field={"DetailsOrComments"} label={"Details/Comments"}  validationRules={validationRules} showAsTextOnly={showAsTextOnly} />
                </div>
        )}
            </div>
        </Dialog>
    )
}

export default EmployeeDetails;


// WEBPACK FOOTER //
// ./src/components/employee/employee-details.js